'use strict';

/** @type {import('./range')} */
module.exports = RangeError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/range.js
// module id = 610
// module chunks = 0